// DO NOT CHANGE -- THIS FILE IS GENERATED

const theme = {
  primary: '#6ab023',
  secondary: '#00305d',
  third: '#a9011b',
};

export default theme;
